import Button from "mobily-ui-library/lib/components/composite/button/Button";
import IconButton from "mobily-ui-library/lib/components/composite/iconButton/IconButton";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import { useContext, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { JSEncrypt } from 'jsencrypt';
import { GlobalContext } from "../../../context/GlobalContext";
import OrderCard from './OrderCard';
import { sendOTP } from '../../../api/api';
import { isEmpty, CheckResponse, Error } from '../../Util/Util';
import './OrderDetails.scss';
import FiberOrderCard from "./FiberOrderCard";
import { FIBERNET_TC_AR, FIBERNET_TC_EN, SIP_TC_AR, SIP_TC_EN, VOICEDATA_TC_AR, VOICEDATA_TC_EN } from "../../../constants";
import CaptchaCustom from "../../Common/CaptchaCustom/CaptchaCustom";



export interface Props {
    rtl: boolean;
    handleHashValue: (value: string) => void;
    handleStatus: (value: string) => void;
}

const win: any = window;

function OrderDetails({ rtl, handleHashValue, handleStatus }: Props) {
    const { t } = useTranslation();
    const [state, dispatch]: any = useContext(GlobalContext);
    const { userType, existingCustomerData, newCustomerData, lang, productInformationData, productType } = state;
    const [recaptchaValue, setRecaptchaValue] = useState<string | null>(null);
    const recaptchaRef = useRef<any>(null);
    


    const dir = rtl ? "right" : "left";
    let downloadFile = lang === 'ar'
        ? VOICEDATA_TC_AR
        : VOICEDATA_TC_EN;
    if (productType === 'Fiber') {
        downloadFile = lang === 'ar'
            ? FIBERNET_TC_AR
            : FIBERNET_TC_EN;
    } else if (productType === 'SIP') {
        downloadFile = lang === 'ar'
            ? SIP_TC_AR
            : SIP_TC_EN;
    }
    let existingMobileNumber: string = !isEmpty(existingCustomerData) && existingCustomerData.prefix + existingCustomerData.mobileNumber;
    let newCustMobileNumber: string = !isEmpty(newCustomerData) && newCustomerData.prefix + newCustomerData.mobileNumber;


    const mobileNumber = userType === 'newcustomer' ? newCustMobileNumber : existingMobileNumber;

    const publicKey = win['BM_PUBLIC_KEY'];
    const jsEncrypt = new JSEncrypt();
    jsEncrypt.setPublicKey(publicKey);

    const onChange = (value: string | null) => {
        setRecaptchaValue(value);
    };

    const handleSubmit = () => {
        if (!recaptchaValue) {
            Error("Captcha is Required");
            return;
        }
        if (!isEmpty(existingCustomerData) || !isEmpty(newCustomerData)) {
            dispatch({ type: 'LOADER', payload: { loading: true } })

            let data = {
                msisdn: jsEncrypt.encrypt(mobileNumber),
                language: jsEncrypt.encrypt(lang.toUpperCase()),
                moduleId: jsEncrypt.encrypt('112'),
                otpLength: jsEncrypt.encrypt('4'),
                isNumeric: jsEncrypt.encrypt('Y')
            };
            sendOTP(data)
                .then((res: any) => {
                    if (res.status === 204) {
                        handleStatus(res.status)
                        handleHashValue(res.headers.hashcode)
                        dispatch({ type: 'LOADER', payload: { loading: false } })
                        setRecaptchaValue(null);
                        recaptchaRef.current?.reset();
                        
                    } else {
                        // const { errorMsg } = CheckResponse(res.data.status, lang);
                        const objCheck = typeof (res.data);
                        const { errorMsg } = objCheck === 'object' ? CheckResponse(res.data.status, lang) : CheckResponse(res, lang);
                        Error(errorMsg)
                        dispatch({ type: 'LOADER', payload: { loading: false } })
                    }
                });
        }

        dispatch({ type: 'ORDER_DETAILS_DATA', payload: { values: '', page: userType === 'newcustomer' || ['Data', 'Voice'].includes(productType) ? t("Download_Attach") : t("Product_Information"), prevModalOpen: true, modalOpen: true } })
    }

    const handleCancel = () => {
        dispatch({ type: 'ORDER_DETAILS_DATA', payload: { values: '', page: userType === 'newcustomer' || ['Data', 'Voice'].includes(productType) ? t("Download_Attach") : t("Product_Information"), prevModalOpen: false, modalOpen: false } })
    }


    const getTermsAndCondition = () => {
        if (['SIP', 'Fiber'].includes(productType)) {
            const termsSentence: any = productType==='SIP' ? t('Accept_statement_SIP') : t('Accept_statement_Fiber');
            const parts = termsSentence.split(t("Terms_Conditions_Link"))
            return (
                <Typography className="orderDetails-text-submit sansFont" rtl={rtl}>
                    {`${parts[0]} `}
                    <a role="button" className='term-conditions sansFont' href={downloadFile} download={'Term & Conditions'} target="_blank" rel="noreferrer">{t('Terms_Conditions_Link')}</a>
                    {` ${parts[1]}`}
                </Typography>
            )
        } else {
            return (
                <Typography className="orderDetails-text-submit sansFont" rtl={rtl}>{t('Accept_statement')}
                    <a role="button" className='term-conditions sansFont' href={downloadFile} download={'Term & Conditions'} target="_blank" rel="noreferrer">{t('Terms_Conditions')}</a>
                </Typography>
            )
        }
    }
    return (
        <>
            <div className='orderDetails-backdrop' />
            <div className={`orderDetails-container fontFamily-${dir}`} >
                <Typography className="orderDetails-title" rtl={rtl}>{t('Your_order_details')}</Typography>
                <>
                    {productInformationData.map((OrderDetailsProduct: any, index: any) => {
                        if (['Fiber', 'SIP'].includes(productType)) {
                            return <FiberOrderCard key={OrderDetailsProduct.productInformation.packageName.value + index} rtl={rtl} OrderDetailsProduct={OrderDetailsProduct}/>
                        } else {
                            return <OrderCard key={OrderDetailsProduct.productInformation.packageName.value + index} rtl={rtl} OrderDetailsProduct={OrderDetailsProduct} />
                        }
                    })}
                </>

                <>
                    <Typography className="orderDetails-text sansFont" rtl={rtl}>{t('Review_statement')}</Typography>
                    {getTermsAndCondition()}
                </>
                <div className="capture">
                    <CaptchaCustom onChange={onChange} rtl={rtl}/>
                </div>
                <IconButton className={`orderDetails-Button ${!recaptchaValue ? 'disabled-btn' : ''}`} rtl={rtl} onClick={handleSubmit} >{t('Submit')}</IconButton>
                <Button className={`orderDetails-noBorderButton dir-${dir}`} primary={false} variant={'default'} rtl={rtl} onClick={handleCancel} >{t('Cancel')}</Button>
            </div>
        </>
    )
}

export default OrderDetails
